module.exports = __webpack_public_path__ + "static/favicon-f0947d54827b45e85b2c2bdc0c70ed56.ico";